import React, { Fragment, useContext } from "react";
import { Nav } from "reactstrap";
import ChatAppContext from "../../../Chat";
import avatar from "../../../../src/assets/images/avatar.png";

const ChatMenu = () => {
  const { selectedUser, selectedUserProfile } =
    useContext(ChatAppContext) || {};

  const renderProfileInfo = (label, value, isLink = false) => {
    if (!value) return null;

    return (
      <div className="mb-2">
        <span className="font-weight-bold" style={{ fontWeight: "bold" }}>
          {label}:
        </span>{" "}
        {isLink ? (
          <a href={value} target="_blank" rel="noopener noreferrer">
            {value}
          </a>
        ) : (
          value
        )}
      </div>
    );
  };

  return (
    <Fragment>
      {/* <Nav tabs className="border-tab nav-primary"> */}
      {/* Uncomment and implement these NavItems if needed */}
      {/* <NavItem id="myTab" role="tablist">
          <NavLink
            tag="a"
            className={activeTab === "1" ? "active" : ""}
            onClick={() => setActiveTab("1")}
          >
            {" "}
            CALL
          </NavLink>
        </NavItem>
        <NavItem id="myTab" role="tablist">
          <NavLink
            tag="a"
            className={activeTab === "2" ? "active" : ""}
            onClick={() => setActiveTab("2")}
          >
            STATUS
          </NavLink>
        </NavItem>
        <NavItem id="myTab" role="tablist">
          <NavLink
            tag="a"
            className={activeTab === "3" ? "active" : ""}
            onClick={() => setActiveTab("3")}
          >
            PROFILE
          </NavLink>
        </NavItem> */}
      {/* </Nav> */}

      <div
        className="user-profile custom-scrollbar"
        style={{ overflowY: "auto", height: "560px" }}
      >
        <div className="image text-center mb-3">
          <img
            className="rounded-circle"
            src={
              selectedUserProfile?.support_chat &&
              !selectedUser?.profile_image
                ? `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    (
                      selectedUserProfile.support_admin_name ||
                      selectedUser?.recruiter_full_name ||
                      "Support"
                    )
                      .toString()
                      .slice(0, 40)
                  )}&background=0D8ABC&color=fff&size=128`
                : selectedUser?.profile_image || avatar
            }
            alt="User Avatar"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
        <div className="user-content text-center">
          <h5 className="text-center text-uppercase mb-2">
            {selectedUserProfile?.support_chat
              ? selectedUserProfile.support_admin_name ||
                selectedUser?.recruiter_full_name ||
                "Support"
              : selectedUser
                ? selectedUser.recruiter_full_name
                : ""}
          </h5>
          {selectedUserProfile?.support_chat ? (
            <Fragment>
              <p className="mb-2 small text-muted">
                This is your private support thread with our team (not a
                recruiter company profile).
              </p>
              {renderProfileInfo(
                "Support contact",
                selectedUserProfile.support_admin_email ||
                  selectedUserProfile.recruiter_email
              )}
            </Fragment>
          ) : (
            <Fragment>
              {selectedUserProfile?.recruiter_email && (
                <p className="mb-2">{selectedUserProfile.recruiter_email}</p>
              )}
              {selectedUserProfile?.status !== undefined && (
                <p className="mb-2">
                  {selectedUserProfile.status ? "Active" : "Inactive"}
                </p>
              )}
            </Fragment>
          )}
          <hr />
          <div
            className="text-left profile-details"
            style={{ margin: "20px", textAlign: "left" }}
          >
            {selectedUserProfile?.support_chat ? (
              <p className="small text-muted mb-0">
                Job and company details are not shown for support staff. Use
                this chat for account or ticket help.
              </p>
            ) : (
              selectedUserProfile && (
                <Fragment>
                  {renderProfileInfo(
                    "Company Name",
                    selectedUserProfile.company_name
                  )}
                  {renderProfileInfo(
                    "Company Email",
                    selectedUserProfile.company_email
                  )}
                  {renderProfileInfo(
                    "Company Phone",
                    selectedUserProfile.company_phone
                  )}
                  {renderProfileInfo("Address", selectedUserProfile.address)}
                  {renderProfileInfo("Zip Code", selectedUserProfile.zip_code)}
                  {renderProfileInfo(
                    "Company Website",
                    selectedUserProfile.company_website,
                    true
                  )}
                </Fragment>
              )
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ChatMenu;
